import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import LoadingOverlay from "./components/LoadingOverlay";

// Page imports
import Home from "./pages/Home";
import { Intern } from "./pages/Intern";
import { Aboutus } from "./pages/Aboutus";
import Courses from "./pages/Courses";
import { Contactus } from "./pages/Contactus";
import Login from "./pages/Login";
import SignUp from "./pages/Signup";
import TestForm from "./pages/TestForm";
import IIITHCourseForm from "./pages/IIITHCourseForm";
import { IIITHPrep } from "./pages/IIITHPrep";
import AiDashboard from "./pages/AiDashboard";
import AiFeatures from "./pages/AiFeatures";
import AiNewFeatures from "./pages/AiNewFeatures";
import AiPreferences from "./pages/AiPreferences";
import InitialInfo from "./pages/Counselling/InitialInfo";
import EducationFormParent from "./pages/Counselling/EducationFlow";
import StreamInfo from "./pages/Counselling/StreamInfo";
import DomainInfo from "./pages/Counselling/DomainInfo";
import FirstForm from "./pages/Counselling/FirstForm";
import WorkshopInfo from "./pages/Counselling/WorkshopInfo";
import CheckOutPage from "./pages/Counselling/CheckOutPage";
import AreaTypeInfo from "./pages/Counselling/AreaTypeInfo";
import DomainInfoForRest from "./pages/Counselling/DomainInfoForRest";

// Lazy loaded components for protected routes
const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const Admissionform = React.lazy(() => import("./pages/Admissionform"));
const DomainSelector = React.lazy(() => import("./pages/DomainSelector"));
const DegreeSelector = React.lazy(() => import("./pages/DegreeSelector"));
const PostGradDegreeSelector = React.lazy(
  () => import("./pages/PostGradDegreeSelector"),
);
const DoctorateDegreeSelector = React.lazy(
  () => import("./pages/DoctorateDegreeSelector"),
);
const StreamSelector = React.lazy(() => import("./pages/StreamSelector"));
const CategorySelection = React.lazy(() => import("./pages/CategorySelection"));
const OtherSelector = React.lazy(
  () => import("./pages/AptitudeCategories/OtherSelector"),
);
const EmployedSelector = React.lazy(
  () => import("./pages/AptitudeCategories/EmployedSelector"),
);
const BusinessSelector = React.lazy(
  () => import("./pages/AptitudeCategories/BusinessSelector"),
);
const BusinessSubSelector = React.lazy(
  () => import("./pages/AptitudeCategories/BusinessSubSelector"),
);
const BusinessSubSubSelector = React.lazy(
  () => import("./pages/AptitudeCategories/BusinessSubSubSelector"),
);

const CheckOut = React.lazy(() => import("./pages/CheckOut"));
const CourseCheckOut = React.lazy(() => import("./pages/CourseCheckOut"));
const AISubscriptionCheckout = React.lazy(
  () => import("./pages/AISubscriptionCheckout"),
);
const IIITHCheckOut = React.lazy(() => import("./pages/IIITHCourseCheckout"));
const TestScreen = React.lazy(() => import("./pages/TestScreen"));
const CourseAView = React.lazy(() => import("./pages/CourseADashboard"));
const CourseBView = React.lazy(() => import("./pages/CourseBDashboard"));
const AptitudeTestView = React.lazy(() => import("./pages/AptitudeDashboard"));
const WorkshopForm = React.lazy(() => import("./pages/WorkshopForm"));
const WorkShopCheckOut = React.lazy(() => import("./pages/WorkshopCheckOut"));
const IIITHCourseSelctionPage = React.lazy(
  () => import("./pages/IIITHCourseSelectionPage"),
);

const CareerCounsellingView = React.lazy(
  () => import("./pages/CounsellingDashboard"),
);
const ReportCardAnalysis = React.lazy(
  () => import("./pages/ReportCardAnalysis"),
);
const AptitudeTestInstructions = React.lazy(
  () => import("./pages/testIntructions"),
);
const AuthGuard = React.lazy(() => import("./components/AuthGuard"));

// Suspense wrapper component
const SuspenseWrapper = ({ children }) => (
  <Suspense fallback={<LoadingOverlay message="Loading..." />}>
    {children}
  </Suspense>
);

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={
        <AuthProvider>
          <App />
        </AuthProvider>
      }
    >
      {/* Public Routes */}
      <Route index element={<Home />} />
      <Route path="home" element={<Home />} />
      <Route path="intern" element={<Intern />} />
      <Route path="aboutus" element={<Aboutus />} />
      <Route path="courses" element={<Courses />} />
      <Route path="iiithprep" element={<IIITHPrep />} />
      <Route path="contactus" element={<Contactus />} />
      {/* <Route path="login" element={<Login />} /> */}
      {/* <Route path="signup" element={<SignUp />} /> */}
      {/* <Route path="AI">
        <Route
          path="dashboard/:conversationId?"
          element={
            <SuspenseWrapper>
              <AiDashboard />
            </SuspenseWrapper>
          }
        />
        <Route
          path="features"
          element={
            <SuspenseWrapper>
              <AiFeatures />
            </SuspenseWrapper>
          }
        />
        <Route
          path="new-features"
          element={
            <SuspenseWrapper>
              <AiNewFeatures />
            </SuspenseWrapper>
          }
        />
        <Route
          path="preferences"
          element={
            <SuspenseWrapper>
              <AiPreferences />
            </SuspenseWrapper>
          }
        />
      </Route> */}

      <Route
        element={
          <SuspenseWrapper>
            <AuthGuard />
          </SuspenseWrapper>
        }
      >
        <Route
          path="dashboard"
          element={
            <SuspenseWrapper>
              <Dashboard />
            </SuspenseWrapper>
          }
        >
          <Route
            path="course-a"
            element={
              <SuspenseWrapper>
                <CourseAView />
              </SuspenseWrapper>
            }
          />
          <Route
            path="course-b"
            element={
              <SuspenseWrapper>
                <CourseBView />
              </SuspenseWrapper>
            }
          />
          <Route
            path="aptitude-test"
            element={
              <SuspenseWrapper>
                <AptitudeTestView />
              </SuspenseWrapper>
            }
          />
          <Route
            path="aptitude-test/reportcard"
            element={
              <SuspenseWrapper>
                <ReportCardAnalysis />
              </SuspenseWrapper>
            }
          />
          <Route
            path="career-counselling"
            element={
              <SuspenseWrapper>
                <CareerCounsellingView />
              </SuspenseWrapper>
            }
          />
        </Route>
        {/* IIITH_prep routes*/}
        <Route path="iiithcourseform" element={<IIITHCourseForm />} />
        <Route
          path="iiithcourseselct"
          element={
            <SuspenseWrapper>
              <IIITHCourseSelctionPage />
            </SuspenseWrapper>
          }
        />
        <Route
          path="iithprepcheckout"
          element={
            <SuspenseWrapper>
              <IIITHCheckOut />
            </SuspenseWrapper>
          }
        />
        {/* Test Flow Routes */}
        <Route
          path="domain"
          element={
            <SuspenseWrapper>
              <DomainSelector />
            </SuspenseWrapper>
          }
        />
        <Route
          path="stream"
          element={
            <SuspenseWrapper>
              <StreamSelector />
            </SuspenseWrapper>
          }
        />
        <Route
          path="other"
          element={
            <SuspenseWrapper>
              <OtherSelector />
            </SuspenseWrapper>
          }
        />
        <Route
          path="employed"
          element={
            <SuspenseWrapper>
              <EmployedSelector />
            </SuspenseWrapper>
          }
        />
        <Route
          path="business"
          element={
            <SuspenseWrapper>
              <BusinessSelector />
            </SuspenseWrapper>
          }
        />
        <Route
          path="business-sub"
          element={
            <SuspenseWrapper>
              <BusinessSubSelector />
            </SuspenseWrapper>
          }
        />
        <Route
          path="business-sub-sub"
          element={
            <SuspenseWrapper>
              <BusinessSubSubSelector />
            </SuspenseWrapper>
          }
        />
        <Route
          path="degree"
          element={
            <SuspenseWrapper>
              <DegreeSelector />
            </SuspenseWrapper>
          }
        />
        <Route
          path="postGradDegree"
          element={
            <SuspenseWrapper>
              <PostGradDegreeSelector />
            </SuspenseWrapper>
          }
        />
        <Route
          path="doctorateDegree"
          element={
            <SuspenseWrapper>
              <DoctorateDegreeSelector />
            </SuspenseWrapper>
          }
        />
        <Route
          path="category"
          element={
            <SuspenseWrapper>
              <CategorySelection />
            </SuspenseWrapper>
          }
        />
        <Route
          path="checkout"
          element={
            <SuspenseWrapper>
              <CheckOut />
            </SuspenseWrapper>
          }
        />
        <Route
          path="workshop-checkout"
          element={
            <SuspenseWrapper>
              <WorkShopCheckOut />
            </SuspenseWrapper>
          }
        />
        <Route
          path="courseCheckout"
          element={
            <SuspenseWrapper>
              <CourseCheckOut />
            </SuspenseWrapper>
          }
        />
        <Route
          path="aiSubscriptionCheckout"
          element={
            <SuspenseWrapper>
              <AISubscriptionCheckout />
            </SuspenseWrapper>
          }
        />
        <Route
          path="testForm"
          element={
            <SuspenseWrapper>
              <TestForm />
            </SuspenseWrapper>
          }
        />
        <Route
          path="workshopForm"
          element={
            <SuspenseWrapper>
              <WorkshopForm />
            </SuspenseWrapper>
          }
        />
        <Route
          path="testinstructions"
          element={
            <SuspenseWrapper>
              <AptitudeTestInstructions />
            </SuspenseWrapper>
          }
        />
        <Route
          path="testscreen/:domainId"
          element={
            <SuspenseWrapper>
              <TestScreen />
            </SuspenseWrapper>
          }
        />
        <Route
          path="admission"
          element={
            <SuspenseWrapper>
              <Admissionform />
            </SuspenseWrapper>
          }
        />
        <Route
          path="initial-info"
          element={
            <SuspenseWrapper>
              <InitialInfo />
            </SuspenseWrapper>
          }
        />
        <Route
          path="areaType-info"
          element={
            <SuspenseWrapper>
              <AreaTypeInfo />
            </SuspenseWrapper>
          }
        />
        <Route
          path="basic-info"
          element={
            <SuspenseWrapper>
              <FirstForm />
            </SuspenseWrapper>
          }
        />

        <Route
          path="past-info"
          element={
            <SuspenseWrapper>
              <EducationFormParent />
            </SuspenseWrapper>
          }
        />
        <Route
          path="counselling-checkout"
          element={
            <SuspenseWrapper>
              <CheckOutPage />
            </SuspenseWrapper>
          }
        />
        <Route
          path="stream-info"
          element={
            <SuspenseWrapper>
              <StreamInfo />
            </SuspenseWrapper>
          }
        />
        <Route
          path="domain-info"
          element={
            <SuspenseWrapper>
              <DomainInfo />
            </SuspenseWrapper>
          }
        />
        <Route
          path="domain-info-for-rest"
          element={
            <SuspenseWrapper>
              <DomainInfoForRest />
            </SuspenseWrapper>
          }
        />
        <Route
          path="workshop-info"
          element={
            <SuspenseWrapper>
              <WorkshopInfo />
            </SuspenseWrapper>
          }
        />
        <Route
          path="reportcard"
          element={
            <SuspenseWrapper>
              <ReportCardAnalysis />
            </SuspenseWrapper>
          }
        />
      </Route>
    </Route>,
  ),
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);

reportWebVitals();
